module.exports = "https://static.energy5.com/_next/static/images/suport-440c5085e169441ff42c922b53ebb188.png";